import { Dispatch, SetStateAction, useCallback } from 'react'
import {
  filterBreadsByCategory,
  filterBreadsByCurrentTab,
  filterBreadsByKeyword,
  filterBreadsByStatus,
  filterBreadsByType,
} from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType, StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { DayOfWeekType } from 'lib/daysOfWeek'

type UseSearchBreadsParams = {
  breads: BreadType[]
  categories: CategoryType[]
  categoryName: string
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
  isShownPrivate: boolean
  breadTypes?: StockUnionType[]
  stocks?: StockType[]
  schedules?: ScheduleType[]
  isFuture?: boolean
  checkedOrderTypes?: string[]
  dayOfWeek?: DayOfWeekType
  isTemporaryClose?: boolean
  currentTab?: 'released' | 'unreleased'
}

const useSearchBreads = (params: UseSearchBreadsParams) => {
  const {
    breads,
    categories,
    categoryName,
    setBreadList,
    isShownPrivate,
    breadTypes,
    stocks,
    schedules,
    isFuture,
    checkedOrderTypes,
    dayOfWeek,
    isTemporaryClose,
    currentTab,
  } = params
  return useCallback(
    (keyword: string) => {
      let _breads = breads
      // カテゴリでフィルターした後にキーワードでフィルタリング
      _breads = filterBreadsByStatus(_breads, isShownPrivate)
      _breads = filterBreadsByCategory(categoryName, categories, _breads)
      _breads = filterBreadsByKeyword(keyword, _breads)
      if (breadTypes) {
        _breads = filterBreadsByType(_breads, breadTypes)
      }
      if (stocks && schedules && dayOfWeek && currentTab && checkedOrderTypes) {
        _breads = filterBreadsByCurrentTab({
          breads: _breads,
          checkedOrderTypes,
          currentTab,
          dayOfWeek,
          stocks,
          schedules,
        })
      }
      setBreadList([..._breads])
    },
    [
      breads,
      categories,
      categoryName,
      setBreadList,
      isShownPrivate,
      breadTypes,
      stocks,
      schedules,
      isFuture,
      checkedOrderTypes,
      dayOfWeek,
      isTemporaryClose,
      currentTab,
    ]
  )
}

export default useSearchBreads
